export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6911.9a8d3be6.jpg";